import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import classnames from 'classnames'
import { adminAddSubject } from '../../redux/action/adminAction'
import AdminHomeHelper from '../../Components/AdminHomeHelper'

const AdminAddSubject = () => {
    const store = useSelector((store) => store)
    const dispatch = useDispatch()
    const history = useHistory()
    const [subjectName, setSubjectName] = useState('')
    const [subjectCode, setSubjectCode] = useState('')
    const [semester, setSemester] = useState('')
    const [subType, setSubjectType] = useState('')
    const [subModel, setSubjectModel] = useState('')
    const [subCredit, setCredit] = useState('')
    const [department, setDepartment] = useState('')
    const [year, setYear] = useState('')
    const [error, setError] = useState({})
    const [isLoading, setIsLoading] = useState(false)


    useEffect(() => {
        if (store.error) {
            setError(store.error)
        }
    }, [store.error])
    const formHandler = (e) => {
        e.preventDefault()
        setIsLoading(true)
        dispatch(adminAddSubject({
            subjectCode,
            subjectName,
            semester,
            subCredit,
            subModel,
            department,
            subType,
            year
        }))
    }

    useEffect(() => {
        if (store.admin.adminAddSubjectFlag) {
            setError({})
        }
    }, [store.admin.adminAddSubjectFlag])

    useEffect(() => {
        if (store.error || store.admin.adminAddSubjectFlag) {
            setIsLoading(false)
        }
    }, [store.error, store.admin.adminAddSubjectFlag])

    return (
        <div>
            {store.admin.isAuthenticated ? <> 
                <div className="container-fluid p-0">
                <div className="d-flex ">
                    <div className="print-helper">
                        <AdminHomeHelper/>
                        </div>
                        <div className="mx-1 w-100 ">
                        <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                                <h3> <img src="/logo192.png" width={'50px'} alt="" />Add Subject</h3>
                                <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                            </div>
                            <div className="d-flex flex-column align-items-center justify-content-center w-100">
                                <form noValidate onSubmit={formHandler} className='w-100'>
                                    <div className="row d-flex my-2 align-items-center justify-content-center w-100">
                                    <div className="col-md-5">
                                    <div className="form-group">
                                        <label htmlFor="snameId">Subject Name</label>
                                        <input onChange={(e) => setSubjectName(e.target.value)} type="text" className={classnames("form-control",
                                            {
                                                'is-invalid': error.subjectName
                                            })} id="snameId" />
                                        {error.subjectName && (<div className="invalid-feedback">{error.subjectName}</div>)}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="scodeId">Subject Code</label>
                                        <input onChange={(e) => setSubjectCode(e.target.value)} type="text" className={classnames("form-control",
                                            {
                                                'is-invalid': error.subjectCode
                                            })} id="scodeId" />
                                        {error.subjectCode && (<div className="invalid-feedback">{error.subjectCode}</div>)}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="CreditId">Credit</label>
                                        <input onChange={(e) => setCredit(e.target.value)} type="text" className={classnames("form-control",
                                            {
                                                'is-invalid': error.credit
                                            })} id="CreditId" />
                                        {error.credit && (<div className="invalid-feedback">{error.credit}</div>)}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="subjectModelId">Subject Model</label>
                                        <select onChange={(e) => setSubjectModel(e.target.value)} className={classnames("form-control",
                                            {
                                                'is-invalid': error.subjectModel
                                            })} id="subjectModelId">
                                            <option>Select</option>
                                            <option value="Normal">Normal</option>
                                            <option value="Professional Elective">Professional Elective</option>
                                            <option value="Open Elective">Open Elective</option>
                                        </select>
                                        {error.subjectModel && (<div className="invalid-feedback">{error.subjectModel}</div>)}
                                    </div>
                                    </div>
                                    <div className="col-md-5">
                                    <div className="form-group">
                                        <label htmlFor="setSubjectTypeId">Subject Type</label>
                                        <select onChange={(e) => setSubjectType(e.target.value)} className={classnames("form-control",
                                            {
                                                'is-invalid': error.subjectType
                                            })} id="setSubjectTypeId">
                                            <option>Select</option>
                                            <option value="Theory">Theory</option>
                                            <option value="Lab come Theory">Lab come Theory</option>
                                            <option value="Practical">Practical</option>
                                            <option value="Others">Others</option>
                                        </select>
                                        {error.subjectType && (<div className="invalid-feedback">{error.subjectType}</div>)}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="semesterId">Semester</label>
                                        <select onChange={(e) => setSemester(e.target.value)} className={classnames("form-control",
                                            {
                                                'is-invalid': error.semester

                                            })} id="semesterId">
                                            <option>Select</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                        </select>

                                        {error.semester && (<div className="invalid-feedback">{error.semester}</div>)}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="departmentId">Department</label>
                                        <select onChange={(e) => setDepartment(e.target.value)} className={classnames("form-control",
                                            {
                                                'is-invalid': error.department
                                            })} id="departmentId">
                                            <option>Select</option>
                                            <option value="ECE">ECE</option>
                                            <option value="EEE">EEE</option>
                                            <option value="CSE">CSE</option>
                                            <option value="AIDS">AIDS</option>
                                            <option value="MECH">MECH</option>
                                            <option value="CIVIL">CIVIL</option>
                                                <option value="BIO">BIO</option>
                                                <option value="AGRI">AGRI</option>
                                                <option value="MBA">MBA</option>
                                                <option value="MCA">MCA</option>
                                        </select>
                                        {error.department && (<div className="invalid-feedback">{error.department}</div>)}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="yearId">Year</label>
                                        <select onChange={(e) => setYear(e.target.value)} className={classnames("form-control",
                                            {
                                                'is-invalid': error.year

                                            })} id="yearId">
                                            <option>Select</option>
                                            <option value="I">I</option>
                                            <option value="II">II</option>
                                            <option value="III">III</option>
                                            <option value="IV">IV</option>
                                        </select>

                                        {error.year && (<div className="invalid-feedback">{error.year}</div>)}
                                    </div>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-md-1">
                                            {
                                                isLoading && <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {!isLoading && <button type="submit" className="btn btn-info m-3 "> <img src="/image/add.svg" className='m-1' alt="" /> Add Subject</button>}
                                   
                                    </div>
                                    
                                </form>
                            </div>
                        </div>
                    </div>
                </div></>: (history.push('/'))}
        </div>
    )
}

export default AdminAddSubject
